import { useTranslation } from 'react-i18next';
import { Box, Typography } from '@mui/material';
import { CheckBox as CheckBoxIcon, CheckBoxOutlineBlank as CheckBoxOutlineBlankIcon } from '@mui/icons-material';
import { extractBestTranslation, formatDate, formatDateTime } from '@utils/helpers';

const ContactSendoutExtra = ({ extra, ...params }) => {
    const { t, i18n } = useTranslation();

    const noValue = <Typography sx={{ color: 'text.secondary', fontStyle: 'italic', display: 'inline' }}>{t('No value')}</Typography>;
    const formatValue = (type, value, enumValues) => {
        switch (type) {
            case 'date':
                return formatDate(value) || noValue;
            case 'datetime':
                return formatDateTime(value) || noValue;
            case 'checkbox':
            case 'switch':
                return value ? <CheckBoxIcon fontSize="small" sx={{ verticalAlign: 'middle' }} />
                    : <CheckBoxOutlineBlankIcon fontSize="small" sx={{ verticalAlign: 'middle' }} />;
            case 'select':
            case 'radios':
                return value
                    ? (enumValues[value] ? extractBestTranslation(enumValues[value], i18n.language) : value) 
                    : noValue;
            case 'selectmultiple':
            case 'checkboxes':
                return value.length > 0
                    ? value.map(v => enumValues[v] ? extractBestTranslation(enumValues[v], i18n.language) : v).join(', ')
                    : noValue;
            case 'textarea':
                return value ? (
                    <Box 
                        sx={{ 
                            backgroundColor: 'grey.300',
                            p: 1,
                            mb: 1,
                            borderRadius: 1,
                            whiteSpace: 'pre-wrap',
                            fontSize: '0.9em'
                        }}
                    >
                        {value}
                    </Box>
                ) : noValue;
            default:
                return value || noValue;
        }
    };

    return (
        extra &&
        <Box {...params}>
            {Object.keys(extra).map((key) => (
                extra[key] &&
                <Typography key={key}>
                    {extractBestTranslation(extra[key].label, i18n.language)}
                    &nbsp;:{' '}
                    {formatValue(extra[key].type, extra[key].value, extra[key]['enum'] ?? null)}
                </Typography>
            ))}
        </Box>
    );
};

export default ContactSendoutExtra;